import React, { Component, PropTypes } from 'react';

export default class EventTeamName extends Component {
  static propTypes = {
    team: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    }).isRequired
  };

  static defaultProps = {
    team: null
  };

  render() {
    const { team } = this.props;

    return (
      <span>{team.name}</span>
    );
  }
}




// WEBPACK FOOTER //
// ./src/js/components/event/EventTeamName.jsx